import { render, staticRenderFns } from "./erweimaLogin.vue?vue&type=template&id=12515569&scoped=true"
import script from "./erweimaLogin.vue?vue&type=script&lang=js"
export * from "./erweimaLogin.vue?vue&type=script&lang=js"
import style0 from "./erweimaLogin.vue?vue&type=style&index=0&id=12515569&lang=css"
import style1 from "./erweimaLogin.vue?vue&type=style&index=1&id=12515569&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12515569",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12515569')) {
      api.createRecord('12515569', component.options)
    } else {
      api.reload('12515569', component.options)
    }
    module.hot.accept("./erweimaLogin.vue?vue&type=template&id=12515569&scoped=true", function () {
      api.rerender('12515569', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/components/loginModal/erweimaLogin.vue"
export default component.exports